import { render, staticRenderFns } from "./privateWelcome.vue?vue&type=template&id=613253d8"
import script from "./privateWelcome.vue?vue&type=script&lang=js"
export * from "./privateWelcome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports